var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMove = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.2 3.75a.5.5 0 0 0-.339.126.32.32 0 0 0-.111.235v7.778c0 .076.032.162.111.235a.5.5 0 0 0 .339.126H7v1.5H3.2a2 2 0 0 1-1.358-.525 1.82 1.82 0 0 1-.592-1.336V4.11c0-.513.22-.992.592-1.336A2 2 0 0 1 3.2 2.25h3.09l2 1.818h4.51a2 2 0 0 1 1.358.525c.371.344.592.823.592 1.336V7h-1.5V5.93a.32.32 0 0 0-.111-.236.5.5 0 0 0-.339-.126H7.71l-2-1.818z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.75 11a.75.75 0 0 1 .75-.75h2.19l-.72-.72a.75.75 0 0 1 1.06-1.06l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l.72-.72H9.5a.75.75 0 0 1-.75-.75"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMove);
export default ForwardRef;